var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-block mt-5 recommend-banners",attrs:{"to":"/lk/recommend"}},[(_vm.state === 1)?_c('img',{attrs:{"src":"/pic/recommend/banner1.svg"}}):(_vm.state)?_c('img',{attrs:{"src":"/pic/recommend/banner2.svg"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }